import React, { useEffect, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import Swal from "sweetalert2";
import CouponMasterApi from "../../Api/CouponMaster";
import { Icon } from "@iconify/react";

const today = () => new Date().toISOString().slice(0, 10);

const CouponMaster = () => {
    const [itemId, setItemId] = useState(null);

    const [couponName, setCouponName] = useState("");
    const [couponDescription, setCouponDescription] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [couponExpiry, setCouponExpiry] = useState(today());

    const [discountValue, setDiscountValue] = useState("");
    const [discountAmt, setDiscountAmt] = useState("");
    const [limitUsed, setLimitUsed] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const res = await CouponMasterApi.GetAllCoupons();
        if (res?.Result) setData(res.Result);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const resetForm = () => {
        setItemId(null);
        setCouponName("");
        setCouponDescription("");
        setCouponCode("");
        setCouponExpiry(today());
        setDiscountValue("");
        setDiscountAmt("");
        setLimitUsed("");
        setIsActive(true);
    };

    const handleSave = async () => {
        const payload = {
            CouponName: couponName.trim(),
            CouponDescription: couponDescription.trim() || null,
            CouponCode: couponCode.toUpperCase().trim(),
            CouponExpiry: couponExpiry,           // Should be YYYY-MM-DD from <input type="date">
            DiscountValue: discountValue || null,
            DiscountAmt: discountAmt || null,
            LimitCouponUsed: limitUsed ? parseInt(limitUsed) : 0,
            CreatedBy: "admin",
        };

        const res = await CouponMasterApi.CreateCoupon(payload);

        if (res?.IsSuccess) {
            Swal.fire("Success", "Coupon Created", "success");
            resetForm();
            fetchData();
        }
    };

    const handleUpdate = async () => {
        const payload = {
            CouponName: couponName,
            CouponDescription: couponDescription,
            CouponCode: couponCode,
            CouponExpiry: couponExpiry,
            DiscountValue: discountValue,
            DiscountAmt: discountAmt,
            LimitCouponUsed: limitUsed,
            IsActive: isActive,
            UpdatedBy: "admin",
        };

        const res = await CouponMasterApi.UpdateCoupon(itemId, payload);

        if (res?.IsSuccess) {
            Swal.fire("Updated", "Coupon Updated", "success");
            resetForm();
            fetchData();
        }
    };

    const formatDateForInput = (date) => {
        if (!date) return today();
        return new Date(date).toISOString().slice(0, 10);
    };

    const handleEdit = (item) => {
        setItemId(item.Id);
        setCouponName(item.CouponName || "");
        setCouponDescription(item.CouponDescription || "");
        setCouponCode(item.CouponCode || "");

        // Safe date handling
        let expDate = today();
        if (item.CouponExpiry) {
            try {
                expDate = new Date(item.CouponExpiry).toISOString().split('T')[0];
            } catch (e) {
                console.warn("Invalid expiry date", item.CouponExpiry);
            }
        }
        setCouponExpiry(expDate);

        setDiscountValue(item.DiscountValue || "");
        setDiscountAmt(item.DiscountAmt || "");
        setLimitUsed(item.LimitCouponUsed?.toString() || "");
        setIsActive(item.IsActive);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Coupon?",
            text: "This action cannot be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        });

        if (!result.isConfirmed) return;

        const res = await CouponMasterApi.DeleteCoupon(id);

        if (res?.IsSuccess) {
            Swal.fire("Deleted", "Coupon deleted", "success");
            fetchData();
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="Flex-general-client-sidebar">
            {/* ---------------- SIDEBAR ---------------- */}
            <div className="sidebar-gen-width">
                <SideBar />
            </div>

            {/* ---------------- MAIN ---------------- */}
            <div className="Main-general-Client">
                <div className="header-general">
                    <h2 className="general-card-title">Coupon Master</h2>
                </div>

                {/* ---------------- FORM ---------------- */}
                <div className="control_radius">
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <input
                                    className="modify_im_input mode_category1"
                                    value={couponName}
                                    onChange={(e) => setCouponName(e.target.value)}
                                    required
                                />
                                <label className="modify_lbl_text3">Coupon Name</label>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <input
                                    className="modify_im_input mode_category1"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                    required
                                />
                                <label className="modify_lbl_text3">Coupon Code</label>
                            </div>
                        </div>

                    </div>

                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <input
                                    type="date"
                                    className="modify_im_input mode_category1"
                                    value={couponExpiry}
                                    onChange={(e) => setCouponExpiry(e.target.value)}
                                />
                                <label className="modify_lbl_text3">Expiry Date</label>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <input
                                    className="modify_im_input mode_category1"
                                    value={limitUsed}
                                    onChange={(e) => setLimitUsed(e.target.value)}
                                />
                                <label className="modify_lbl_text3">Limit Usage</label>
                            </div>
                        </div>

                    </div>

                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <select className="modify_im_input mode_category1" value={discountValue} onChange={(e) => setDiscountValue(e.target.value)}>
                                    <option value="">Select</option>
                                    {/*<option value="Percentage">Percentage (%)</option>*/}
                                    <option value="Fixed">Fixed Amount (₹)</option>
                                </select>
                                <label className="modify_lbl_text3">Discount Type</label>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <input
                                    className="modify_im_input mode_category1"
                                    value={discountAmt}
                                    onChange={(e) => setDiscountAmt(e.target.value)}
                                />
                                <label className="modify_lbl_text3">Discount Amount</label>
                            </div>
                        </div>

                    </div>

                    <div className="company_control">
                        <div className="stock-im-dep1 full-width">
                            <div className="input-box-Imo1">
                                <textarea
                                    className="modify_im_input mode_category1"
                                    value={couponDescription}
                                    onChange={(e) => setCouponDescription(e.target.value)}
                                />
                                <label className="modify_lbl_text3">Description</label>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <select
                                    className="modify_im_input mode_category1"
                                    value={isActive}
                                    onChange={(e) => setIsActive(e.target.value === "true")}
                                >
                                    <option value={true}>Active</option>
                                    <option value={false}>Inactive</option>
                                </select>
                                <label className="modify_lbl_text3">Status</label>
                            </div>
                        </div>
                    </div>

                    {/* ---------------- BUTTON ---------------- */}
                    <div className="ButtonTabSave">
                        {itemId ? (
                            <button
                                className="update-button-main-save hovered"
                                onClick={handleUpdate}
                            >
                                Update
                            </button>
                        ) : (
                            <button
                                className="save-button-main-save hovered"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}

                        {itemId && (
                            <button className="cancel-button" onClick={resetForm}>
                                Cancel
                            </button>
                        )}
                    </div>

                    {/* ---------------- TABLE ---------------- */}
                    <div className="company_info-text-im depart_top">
                        Coupon List
                    </div>

                    <div className="table-account-manager">
                        <table className="table-master-acc">
                            <thead className="header-table-account">
                                <tr>
                                    <th className="table-header-manager ac-sno-wth">S.No</th>
                                    <th className="table-header-manager">Name</th>
                                    <th className="table-header-manager">Code</th>
                                    <th className="table-header-manager">Expiry</th>
                                    <th className="table-header-manager">Discount</th>
                                    <th className="table-header-manager">Limit</th>
                                    <th className="table-header-manager">Status</th>
                                    <th className="table-header-manager">Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={item.Id}>
                                        <td className="table-data-account ac-sno-wth">
                                            {idx + 1}
                                        </td>
                                        <td className="table-data-account">
                                            {item.CouponName}
                                        </td>
                                        <td className="table-data-account">
                                            {item.CouponCode}
                                        </td>
                                        <td className="table-data-account">
                                            {formatDate(item.CouponExpiry)}
                                        </td>
                                        <td className="table-data-account">
                                            {item.DiscountValue} / {item.DiscountAmt}
                                        </td>
                                        <td className="table-data-account">
                                            {item.LimitCouponUsed}
                                        </td>
                                        <td className="table-data-account">
                                            {item.IsActive ? "Active" : "Inactive"}
                                        </td>

                                        <td className="table-data-account">
                                            <button
                                                className="edit-btn-acc"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <Icon icon="lucide:edit" />
                                            </button>

                                            <button
                                                className="delete-btn-acc"
                                                onClick={() => handleDelete(item.Id)}
                                            >
                                                <Icon icon="material-symbols:delete" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CouponMaster;